import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewCustomerComponent } from './new-customer.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DxButtonModule, DxCheckBoxModule, DxSelectBoxModule, DxTextAreaModule, DxTextBoxModule } from 'devextreme-angular';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';


@NgModule({
  declarations: [
    NewCustomerComponent
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxButtonModule,
    DxTextAreaModule,
    GooglePlaceModule,
  ],
    exports: [NewCustomerComponent]
})
export class NewCustomerModule { }
